import React, { PureComponent } from 'react';
import classnames from 'classnames';

import Icon from '~/core/scripts/components/Icon';
import { numberFormat } from '~/core/scripts/utils';
import { colorScale } from '../SalaryApp/utils';
import ac from '../appconfig';

function TimeIcon({ time, timeLabel, iconType, displayEmpty }) {
  if (!Boolean(time) && !displayEmpty) {
    return null;
  }

  // if year = 1 => Jahre => Jahr, etc pp
  timeLabel = time === 1 ? timeLabel.substr(0, timeLabel.length - 1) : timeLabel;

  return (
    <div className="salary__item-time">
      <div className="salary__item-time-text">
        <div className="salary__item-time-number">{time}
          <div className="salary__item-time-label">{timeLabel}</div>
        </div>
      </div>
      <Icon type={iconType} />
    </div>
  );
}

class SalaryItem extends PureComponent {
  render() {
    const { isUser, profession, subtitle, wage, years, months, days } = this.props;
    const itemClasses = classnames('salary__item', { user: isUser });
    const salaryColor = colorScale(wage);
    const background = isUser ? 'transparent' : salaryColor;
    const borderColor = isUser ? salaryColor : 'none';

    return (
      <div className={itemClasses} style={{ background, borderColor }}>
        <div className="salary__item-info">
          <div className="salary__item-job">{profession}</div>
          {subtitle && <div className="salary__item-sub">{subtitle}</div>}
          <div className="salary__item-wage">∅ {numberFormat(wage, 0)} €</div>
        </div>
        <div className="salary__item-timewrapper">
          {isUser && <div className="salary__item-usermessage">{ac.userItemText}</div>}
          <TimeIcon time={years} displayEmpty={false} timeLabel="Jahre" iconType="year" />
          <TimeIcon time={months} displayEmpty={Boolean(years)} timeLabel="Monate" iconType="month" />
          <TimeIcon time={days} displayEmpty={!isUser} timeLabel="Tage" iconType="day" />
        </div>
      </div>
    );
  }
}

export default SalaryItem;